import {
  Box,
  Checkbox,
  Menu,
  MenuItem,
  Pagination,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiSortAlt2 } from "react-icons/bi";
import { SlOptionsVertical } from "react-icons/sl";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineArrowRight } from "react-icons/ai";
import { scholarshipApplicationConvertToLeadAction } from "../../actions/LandingPageAction";
import Swal from "sweetalert2";
import { SUCCESS_TRUE_MSG_ERR } from "../../constants/roleManagmentConstant";
import { successTrueMsgAction } from "../../actions/globalAction";
import { scholarshipApplicationAction } from "../../actions/LandingPageAction";
import { talkToexpertConvertToLeadAction } from "../../actions/LandingPageAction";
import ExpandableTableCell from "../extraComponents/expandableTableCell";

function EnquiryTable({
  data,
  columns,
  pagiantionEntry,
  paginationPageNumber,
  totalEntry,
  handlePageNation,
  counsilorNote,
  teleCallerNote
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { talktoExpertConvertToLeadSuccess, talktoExpertConvertToLeadErr } =
    useSelector((state) => state.talktoExpertConvertToLead);

  let { successAlertMsgSuccess, successAlertMsgErr } = useSelector((state) => {
    return state.successTrueMsg;
  });

  const { scholarshipApplicationSuccess } = useSelector(
    (state) => state.scholarshipApplication
  );

  const {
    scholarshipApplicationConvertToLeadSuccess,
    scholarshipApplicationConvertToLeadErr
  } = useSelector((state) => state.scholarshipApplicationConvertToLead);

  useEffect(() => {
    dispatch(scholarshipApplicationAction());
  }, [dispatch, scholarshipApplicationConvertToLeadSuccess]);

  useEffect(() => {
    if (scholarshipApplicationConvertToLeadSuccess && successAlertMsgSuccess) {
      Swal.fire("Converted!", "converted Successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
    if (scholarshipApplicationConvertToLeadErr && successAlertMsgErr) {
      Swal.fire(
        "Error!",
        scholarshipApplicationConvertToLeadErr.message,
        "error"
      );
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
    }
  }, [
    scholarshipApplicationConvertToLeadSuccess,
    scholarshipApplicationConvertToLeadErr,
    successAlertMsgSuccess,
    successAlertMsgErr
  ]);

  useEffect(() => {
    if (talktoExpertConvertToLeadSuccess && successAlertMsgSuccess) {
      Swal.fire("Converted!", "converted Successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
    if (talktoExpertConvertToLeadErr && successAlertMsgErr) {
      Swal.fire("Error!", "Already a lead.", "error");
      dispatch({ type: SUCCESS_TRUE_MSG_ERR, payload: false });
    }
  }, [
    talktoExpertConvertToLeadSuccess,
    talktoExpertConvertToLeadErr,
    successAlertMsgSuccess,
    successAlertMsgErr
  ]);

  let { enquiryStudentDetailsSuccess, enquiryStudentDetailsLoading } =
    useSelector((state) => state.enquiryStudentDetails);

  const [selectedRows, setSelectedRows] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  // pagination

  const [page, setPage] = useState(paginationPageNumber);
  const [rowsPerPage, setRowsPerPage] = useState(pagiantionEntry);
  const [currentRow, setCurrentRow] = useState(0);

  useEffect(() => {
    setRowsPerPage(pagiantionEntry);
    setPage(paginationPageNumber);
  }, [data, paginationPageNumber, pagiantionEntry]);

  useEffect(() => {
    const maxPage = Math.ceil(totalEntry / pagiantionEntry);
    if (page > maxPage) {
      setPage(maxPage);
    }
  }, [data, pagiantionEntry, page]);

  // pagination

  // // Event handler for changing page
  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // Create a function to handle selecting all rows:
  const handleSelectAllRows = () => {
    if (selectedRows.length === sortedData.length) {
      setSelectedRows([]);
    } else {
      let Ids = sortedData.map((item) => item.id);
      setSelectedRows(Ids);
    }
  };

  // Create a function to handle selecting individual rows:
  const handleSelectRow = (rowId) => {
    let updatedSelectedRows;
    if (selectedRows.includes(rowId)) {
      updatedSelectedRows = selectedRows.filter((id) => id !== rowId);
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      updatedSelectedRows = [...selectedRows, rowId];
      setSelectedRows(updatedSelectedRows);
    }
  };

  // table action
  const [leadActionButtonShow, setLeadActionButtonShow] = useState(null);
  const [tableId, setTableId] = useState("");

  const leadOpenActionButton = Boolean(leadActionButtonShow);

  const handleClickAction = (event, id, indx) => {
    setCurrentRow(indx);

    setLeadActionButtonShow(event.currentTarget);
    setTableId(id);
  };

  const handleCloseAction = () => {
    setLeadActionButtonShow(null);
  };

  const CustomSortIcon = ({ direction }) => {
    return direction === "asc" ? (
      <img
        src="/menuIcons/tableUpSort.png"
        className="administratCustomIcon"
        alt="gsl"
        style={{ padding: "15px" }}
      />
    ) : (
      <BiSortAlt2 className="LeadCustomIcon" />
    );
  };

  // sorting table
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");

  const requestSort = (column) => {
    let newSortOrder = "asc";
    if (column === sortBy && sortOrder === "asc") {
      newSortOrder = "desc";
    }

    setSortBy(column);
    setSortOrder(newSortOrder);
  };

  let sortedData = useMemo(() => {
    if (sortBy && data) {
      const sortedItems = [...data].sort((a, b) => {
        if (sortOrder === "asc") {
          return a[sortBy] < b[sortBy] ? -1 : 1;
        } else {
          return a[sortBy] < b[sortBy] ? 1 : -1;
        }
      });

      return sortedItems;
    }

    return data;
  }, [data, sortBy, sortOrder]);

  const getSourceLabel = (source) => {
    switch (source) {
      case "scholarshipData":
        return "Apply Scholarship";
      case "talkToExpertData":
        return "Talk to Expert";
      case "partnerLead":
        return "Partner";
      case "created":
        return "GSL Lead";
      default:
        return "-";
    }
  };

  return (
    <Box>
      {enquiryStudentDetailsLoading ? (
        <>
          {/* <Skeleton /> */}
          <Typography variant="h1">
            <Skeleton animation={false} />
          </Typography>

          <Typography variant="h3">
            <Skeleton animation="wave" />
          </Typography>

          <Skeleton animation={false} />
          <Typography variant="h3">
            <Skeleton animation="wave" />
          </Typography>

          <Skeleton animation={false} />
          <Typography variant="h3">
            <Skeleton animation="wave" />
          </Typography>

          <Skeleton animation={false} />
          <Typography variant="h3">
            <Skeleton animation="wave" />
          </Typography>

          <Skeleton animation={false} />
        </>
      ) : (
        <>
          <div
            style={{
              overflowX: "scroll",
              border: "0px solid #ffff"
            }}
            className="scrollBar"
          >
            <Table className="LeadTable">
              <TableHead>
                <TableRow className="LeadTableCell">
                  <TableCell
                    style={{
                      position: "sticky",
                      left: 0,
                      zIndex: 1,
                      padding: "1px",
                      border: "1px solid #ddd",
                      backgroundColor: "#fafafa"
                    }}
                  >
                    <Checkbox
                      checked={selectedRows?.length === sortedData?.length}
                      onChange={handleSelectAllRows}
                      style={{ color: "#f81b82" }}
                    />
                  </TableCell>
                  {columns?.map((column) => {
                    if (column.hidden) {
                      return null;
                    }
                    return (
                      <TableCell
                        key={column.field}
                        className="LeadTableCell LeadCommon"
                        style={{
                          padding: "0 16px",
                          whiteSpace: "nowrap",
                          textTransform: "uppercase",
                          fontWeight: "600"
                        }}
                      >
                        <TableSortLabel
                          className="LeadHeaderText"
                          active={column === sortBy}
                          direction={sortOrder}
                          onClick={() => requestSort(column)}
                          IconComponent={
                            column.field !== "action" && CustomSortIcon
                          }
                        >
                          {column.title}
                        </TableSortLabel>
                      </TableCell>
                    );
                  })}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedData.map((item, indx) => (
                  <TableRow className="LeadTable" key={indx}>
                    <TableCell
                      style={{
                        position: "sticky",
                        left: 0,
                        zIndex: 1, // To ensure it's above other cells
                        backgroundColor: "white", // Adjust as needed
                        padding: "1px",
                        border: "1px solid #ddd"
                      }}
                    >
                      <Checkbox
                        checked={selectedRows.includes(indx)}
                        onChange={() => handleSelectRow(indx)}
                        style={{ color: "#f81b82" }}
                      />
                    </TableCell>
                    <TableCell
                      style={{ padding: "0 16px", whiteSpace: "nowrap" }}
                    >
                      {(paginationPageNumber - 1) * 25 + indx + 1}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {(item?.firstName ||
                        item?.fullName ||
                        item?.lead?.firstName ||
                        "") +
                        " " +
                        (item?.lastName || "")}
                    </TableCell>
                    <TableCell
                      style={{ padding: "0 16px", whiteSpace: "nowrap" }}
                    >
                      {item?.email || item?.lead.email || " - "}
                    </TableCell>
                    <TableCell
                      style={{ padding: "0 16px", whiteSpace: "nowrap" }}
                    >
                      {item?.mobileNumber
                        ? `${item?.countryCode ? item?.countryCode + " " : ""}${item?.mobileNumber
                        }`
                        : item?.phoneNumber
                          ? `${item?.countryCode ? item?.countryCode + " " : ""}${item?.phoneNumber
                          }`
                          : item?.lead?.mobileNumber
                            ? `${item?.lead?.countryId
                              ? item?.lead?.countryId + " "
                              : ""
                            }${item?.lead?.mobileNumber}`
                            : "-"}
                    </TableCell>
                    <TableCell
                      style={{ padding: "0 16px", whiteSpace: "nowrap" }}
                    >
                      {item?.whatsappNumber
                        ? (item?.countryId ? item?.countryId : "") +
                        " " +
                        item?.whatsappNumber
                        : "-"}
                    </TableCell>
                    <TableCell
                      style={{ padding: "0 16px", whiteSpace: "nowrap" }}
                    >
                      {item?.lead_personal_details?.[0]?.passportNumber || "-"}
                    </TableCell>

                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item?.livingCountry || " - "}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item.leadSource || " - "}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item?.leadOwnerName || " - "}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item?.Counselor?.firstName || " - "}
                    </TableCell>
                    {/* <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {counsilorNote?.leadId == item?.id
                        ? counsilorNote?.counsilorNote
                        : "-"}
                    </TableCell> */}

                    <ExpandableTableCell
                      text={
                        counsilorNote?.leadId == item?.id
                          ? counsilorNote?.counsilorNote
                          : "-"
                      }
                    />

                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item.Telecaller?.firstName || " - "}
                    </TableCell>
                    {/* <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {teleCallerNote?.leadId == item?.id
                        ? teleCallerNote?.teleCallerNote
                        : "-"}
                    </TableCell> */}

                    <ExpandableTableCell
                      text={
                        teleCallerNote?.leadId == item?.id
                          ? teleCallerNote?.teleCallerNote
                          : "-"
                      }
                    />

                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item?.branch_master?.branchName || " - "}
                    </TableCell>
                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item?.conversionStatus || "_"}
                    </TableCell>

                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap",
                        textTransform: "capitalize"
                      }}
                    >
                      {item?.leadStatus || "_"}
                    </TableCell>

                    <TableCell
                      style={{
                        padding: "0 16px",
                        whiteSpace: "nowrap"
                      }}
                    >
                      <SlOptionsVertical
                        id="demo-positioned-button"
                        aria-controls={
                          leadOpenActionButton
                            ? "demo-positioned-menu"
                            : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={
                          leadOpenActionButton ? "true" : undefined
                        }
                        onClick={(e) => {
                          handleClickAction(e, item?.id, indx);
                        }}
                        variant="outlined"
                        style={{ marginLeft: "10px", color: "#F80B7A" }}
                        sx={{
                          backgroundColor: "#141E3C",
                          size: "10px",
                          padding: 1,
                          margin: 3,
                          color: "#fff",
                          width: "75px",
                          height: "40px"
                        }}
                      />
                      {/* TABLE ACTION MENU START*/}
                      {currentRow === indx && (
                        <Menu
                          id="demo-positioned-menu"
                          aria-labelledby="demo-positioned-button"
                          open={leadActionButtonShow}
                          onClose={handleCloseAction}
                          anchorEl={leadActionButtonShow}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                            sx: {
                              backgroundColor: "white",
                              borderRadius: "12px"
                            } // Move background color here
                          }}
                          PaperProps={{
                            sx: { borderColor: "black", borderRadius: "24px" } // Apply border color to the menu itself
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column", // Arrange items vertically
                              justifyContent: "flex-start",
                              padding: "5px"
                            }}
                          >
                            <MenuItem
                              onClick={() =>
                                navigate(`/enquiry/application/${tableId}`)
                              }
                            >
                              <AiOutlineEye
                                style={{
                                  width: "20px",
                                  height: "19px",
                                  marginRight: "8px"
                                }}
                              />
                              View Details
                            </MenuItem>

                            {(item?.leadSource === "scholarshipData" ||
                              item?.leadSource === "talkToExpertData") && (
                                <MenuItem
                                  onClick={() => {
                                    if (item?.leadSource === "scholarshipData") {
                                      dispatch(
                                        scholarshipApplicationConvertToLeadAction(
                                          item?.fullName || item?.lead?.firstName,
                                          item?.email,
                                          item?.phoneNumber,
                                          item?.countryCode
                                        )
                                      );
                                    } else if (
                                      item?.leadSource === "talkToExpertData"
                                    ) {
                                      dispatch(
                                        talkToexpertConvertToLeadAction(
                                          item?.fullName || item?.lead?.firstName,
                                          item?.email,
                                          item?.phoneNumber,
                                          item?.countryCode
                                        )
                                      );
                                    }
                                  }}
                                  sx={{
                                    borderTop: "1px solid #ddd" // Add a border to separate items
                                  }}
                                >
                                  <AiOutlineArrowRight
                                    style={{
                                      width: "20px",
                                      height: "19px",
                                      marginRight: "8px"
                                    }}
                                  />
                                  Convert to Lead
                                </MenuItem>
                              )}
                          </Box>
                        </Menu>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter />
            </Table>
          </div>
          <Pagination
            sx={{
              mt: "28px",
              "& .Mui-selected": {
                background: "#FE0B7A !important"
              },
              "& .MuiPagination-ul": {
                justifyContent: "end"
              }
            }}
            count={Math.ceil(totalEntry / 25)}
            page={paginationPageNumber}
            onChange={handlePageNation}
            color="primary"
          />
        </>
      )}
    </Box>
  );
}

export default EnquiryTable;
